import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-component-loader',
  templateUrl: './component-loader.component.html',
  styleUrls: ['./component-loader.component.css']
})
export class ComponentLoaderComponent implements OnInit {

  @Input() isLoading = false;
  
  constructor() { }

  ngOnInit(): void {
  }

}
